import "core-js/modules/es6.array.for-each.js";
import "core-js/modules/es6.function.bind.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.map.js";
import _objectSpread from '@babel/runtime/helpers/esm/objectSpread';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import _asyncToGenerator from '@babel/runtime/helpers/esm/asyncToGenerator';
import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import _assertThisInitialized from '@babel/runtime/helpers/esm/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React, { Component, createElement } from 'react';
import classnames from 'classnames';
import tinycolor from 'tinycolor2';
import _extends from '@babel/runtime/helpers/esm/extends';
import distanceInWordsStrict from 'date-fns/distance_in_words_strict';
import '@babel/runtime/helpers/esm/construct';
import Observable from 'zen-observable';
import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import { createStore } from 'redux';

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".FBWContactForm {\n  display: flex;\n  align-items: stretch;\n  flex-direction: column;\n}\n\n.FBWContactForm-Field {\n  flex: 0 1 auto;\n}\n\n.FBWContactForm-Textarea {\n  flex: 1 1 auto;\n}\n\n.FBWContactForm-Button {\n  transition: opacity 0.4s ease-out;\n  cursor: pointer;\n  align-self: flex-end;\n  margin-left: 10px;\n}\n\n.FBWContactForm-Buttons {\n  padding: 10px 15px;\n  text-align: right;\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  justify-content: flex-end;\n}\n\n.FBWContactForm-Button:hover {\n  opacity: 0.7;\n}\n\n.FBWContactForm-Error {\n  color: #F44336;\n}\n\n.FBWContactForm-SuccessOverlay {\n  position: absolute;\n  left: 0; top: 0; bottom: 0; right: 0;\n  text-align: center;\n  font-size: 18px;\n  background-color: white;\n  padding: 20px;\n  padding-top: 40%;\n  visibility: hidden;\n  z-index: -999;\n  opacity: 0;\n  transition: all 0.4s ease-out;\n}\n\n.FBWContactForm-SuccessOverlay--visible {\n  z-index: 999;\n  opacity: 1;\n  visibility: visible;\n}\n\n.FBWContactForm textarea, .FBWContactForm input, .FBWContactForm button {\n  font-family: inherit;\n  font-size: inherit;\n  outline: none;\n  padding: 5px;\n\n  border: 1px transparent solid;\n}\n.FBWContactForm textarea, .FBWContactForm input {\n  display: block;\n  font-size: 13px;\n  line-height: 19px;\n  border-bottom: 1px solid silver;\n  padding: 10px;\n\n  transition : background 500ms ease-out;\n}\n.FBWContactForm textarea {\n  resize: none;\n}\n.FBWContactForm textarea:focus, .FBWContactForm input:focus {\n  background: #FFF3E0;\n  background: var(--focus-color);\n}\n.FBWContactForm button {\n  display: inline-block;\n  margin-right: 0px;\n  border: 0;\n  font-size: 15px;\n  color: white;\n  padding: 10px 15px;\n  border-radius: 3px;\n}\n.FBWContactForm button:hover {\n  opacity: 0.9;\n}\n";
styleInject(css); //     

function hasGlobalConfig() {
  if (window.Feedbackwidget && window.Feedbackwidget.getConfig) {
    return true;
  }

  return false;
}

function getGlobalConfig() {
  if (!hasGlobalConfig()) {
    throw new Error('Feedbackwidgetlib was not properly loaded. Expected to find the window.Feedbackwidget.getConfig function.');
  }

  return window.Feedbackwidget.getConfig();
}

function getDefaultPluginHost() {
  if (window.Feedbackwidget && window.Feedbackwidget.getDefaultPluginHost) {
    var _window$Feedbackwidge2;

    return (_window$Feedbackwidge2 = window.Feedbackwidget).getDefaultPluginHost.apply(_window$Feedbackwidge2, arguments);
  }

  throw new Error('Feedbackwidgetlib was not properly loaded. Expected to find the window.Feedbackwidget.getDefaultPluginHost function.');
}

function getDefaultManager() {
  if (window.Feedbackwidget && window.Feedbackwidget.getDefaultManager) {
    return window.Feedbackwidget.getDefaultManager();
  }

  throw new Error("The API-portion of feedbackwidget-lib is not available\n   in the global scope. If you are working with the npm library, manually\n   pass an \"api\" prop to your components. If you are working with <script>\n   tags, ensure that the trigger-portion of feedbackwidget-lib has been\n   loaded.");
}

var css$1 = ".FBWHeader {\n  padding: 10px;\n\n  background: #FF9800;\n  color: white;\n\n  display: flex;\n  flex-direction: row;\n  flex-shrink: 0;\n  align-items: flex-start;\n}\n\n.FBWHeader--center-aligned .FBWHeader__Content {\n  text-align: center;\n  flex: 1;\n}\n\n.FBWHeader__Content {\n  flex: 1;\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-self: stretch;\n}\n\n.FBWHeader__Title {\n  font-size: 1.1em;\n  line-height: 1; /* To make the centering perfect */\n}\n\n.FBWHeader__Subtitle {\n  font-size: 0.8em;\n  color: #ffffffbd;\n  margin-top: 0.7em;\n}\n\n.FBWHeader__Button {\n  padding: 15px;\n  border-radius: 5%;\n  transition: background 200ms ease-in-out;\n  cursor: pointer;\n  line-height: 0;\n}\n\n.FBWHeader__Button svg {\n  fill: white;\n  width: 20px;\n  height: 20px;\n}\n\n.FBWHeader__Button:hover {\n  background: rgba(0,0,0,0.3);\n}\n\n.FBWHeader__BackButton {\n  margin-right: 5px;\n}\n\n.FBWHeader__CloseButton {\n  margin-left: 5px;\n}\n";
styleInject(css$1);

function CloseIcon(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26",
    version: "1.1",
    width: "26",
    height: "26"
  }, props), React.createElement("g", {
    id: "surface1"
  }, React.createElement("path", {
    style: " ",
    d: "M 21.734375 19.640625 L 19.636719 21.734375 C 19.253906 22.121094 18.628906 22.121094 18.242188 21.734375 L 13 16.496094 L 7.761719 21.734375 C 7.375 22.121094 6.746094 22.121094 6.363281 21.734375 L 4.265625 19.640625 C 3.878906 19.253906 3.878906 18.628906 4.265625 18.242188 L 9.503906 13 L 4.265625 7.761719 C 3.882813 7.371094 3.882813 6.742188 4.265625 6.363281 L 6.363281 4.265625 C 6.746094 3.878906 7.375 3.878906 7.761719 4.265625 L 13 9.507813 L 18.242188 4.265625 C 18.628906 3.878906 19.257813 3.878906 19.636719 4.265625 L 21.734375 6.359375 C 22.121094 6.746094 22.121094 7.375 21.738281 7.761719 L 16.496094 13 L 21.734375 18.242188 C 22.121094 18.628906 22.121094 19.253906 21.734375 19.640625 Z "
  })));
}

var Header =
/*#__PURE__*/
function (_Component) {
  _inherits(Header, _Component);

  function Header() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Header);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Header)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleBackClick", function () {
      if (_this.props.onBackButtonClick) {
        _this.props.onBackButtonClick();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleCloseClick", function () {
      if (_this.props.onCloseButtonClick) {
        _this.props.onCloseButtonClick();
      }
    });

    return _this;
  }

  _createClass(Header, [{
    key: "render",
    value: function render() {
      var _classnames;

      var _this$props = this.props,
          showBackButton = _this$props.showBackButton,
          showCloseButton = _this$props.showCloseButton,
          color = _this$props.color,
          title = _this$props.title,
          subtitle = _this$props.subtitle;
      return React.createElement("div", {
        className: classnames((_classnames = {}, _defineProperty(_classnames, "FBWHeader", true), _defineProperty(_classnames, 'FBWHeader--center-aligned', !this.props.showBackButton), _classnames)),
        style: {
          background: color
        }
      }, showBackButton && React.createElement("div", {
        className: "FBWHeader__Button FBWHeader__BackButton",
        onClick: this.handleBackClick
      }, React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 48 48",
        width: "15",
        height: "15"
      }, React.createElement("path", {
        d: "M 30.898438 43 L 34 39.898438 L 18.101563 24 L 34 8.101563 L 30.898438 5 L 12 24 Z"
      }))), React.createElement("span", {
        className: "FBWHeader__Content"
      }, React.createElement("span", {
        className: "FBWHeader__Title"
      }, title || "Send feedback"), subtitle && React.createElement("div", {
        className: "FBWHeader__Subtitle"
      }, subtitle)), showCloseButton && React.createElement("div", {
        className: "FBWHeader__Button FBWHeader__CloseButton",
        onClick: this.handleCloseClick
      }, React.createElement(CloseIcon, null)));
    }
  }]);

  return Header;
}(Component);

var DEFAULT_COLOR = '#000000'; // TODO: Validate contact.
// - Find email or phone or both.
// - If nothing found, show message "we may not be able to contact you"
// - If the live chat is active, this field is not required!

var ContactForm =
/*#__PURE__*/
function (_Component) {
  _inherits(ContactForm, _Component);

  function ContactForm() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ContactForm);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ContactForm)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      message: '',
      contact: '',
      error: null,
      wasSubmitted: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleSend",
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(e) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();

                if (!_this.state.message) {
                  _context.next = 15;
                  break;
                }

                _context.prev = 2;
                _context.next = 5;
                return _this.manager.identify({
                  email: _this.state.contact
                });

              case 5:
                _context.next = 7;
                return _this.manager.newChat({
                  message: _this.state.message
                });

              case 7:
                _this.setState({
                  wasSubmitted: true
                });

                window.setTimeout(function () {
                  if (_this.props.onClose) {
                    _this.props.onClose();
                  }

                  _this.setState({
                    wasSubmitted: false,
                    message: '',
                    error: '',
                    contact: ''
                  });
                }, 3000);
                _context.next = 15;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](2);
                console.log(_context.t0);

                _this.setState({
                  error: 'Sending failed!'
                });

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 11]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    return _this;
  }

  _createClass(ContactForm, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          title = _this$props.title,
          subtitle = _this$props.subtitle,
          color = _this$props.color,
          textPrompt = _this$props.textPrompt,
          contactPrompt = _this$props.contactPrompt,
          buttonText = _this$props.buttonText,
          onClose = _this$props.onClose,
          style = _this$props.style,
          showCloseButton = _this$props.showCloseButton,
          onRequestClose = _this$props.onRequestClose;
      return React.createElement("form", {
        className: "FBWContactForm",
        onSubmit: this.handleSend,
        style: _objectSpread({
          '--focus-color': tinycolor(color).setAlpha(.1)
        }, style)
      }, React.createElement(Header, {
        color: color,
        title: title,
        subtitle: subtitle,
        showCloseButton: showCloseButton,
        onCloseButtonClick: onRequestClose
      }), React.createElement("textarea", {
        className: "FBWContactForm-Field FBWContactForm-Textarea",
        name: "message",
        required: true,
        autoFocus: true,
        placeholder: textPrompt,
        value: this.state.message,
        onChange: function onChange(e) {
          return _this2.setState({
            message: e.target.value
          });
        }
      }), React.createElement("input", {
        name: "sender",
        className: "FBWContactForm-Field",
        placeholder: contactPrompt,
        value: this.state.contact,
        onChange: function onChange(e) {
          return _this2.setState({
            contact: e.target.value
          });
        }
      }), React.createElement("div", {
        className: "FBWContactForm-Buttons"
      }, this.state.error && React.createElement("div", {
        className: "FBWContactForm-Error"
      }, this.state.error), React.createElement("button", {
        type: "submit",
        className: "FBWContactForm-Button",
        onClick: this.handleSend,
        style: {
          backgroundColor: color
        }
      }, buttonText)), React.createElement("div", {
        className: classnames('FBWContactForm-SuccessOverlay', this.state.wasSubmitted && 'FBWContactForm-SuccessOverlay--visible')
      }, "Thank you!", React.createElement("br", null), "Message was sent."));
    }
  }, {
    key: "manager",
    get: function get() {
      return this.props.manager || getDefaultManager();
    }
  }]);

  return ContactForm;
}(Component);

_defineProperty(ContactForm, "defaultProps", {
  title: 'Send a message',
  textPrompt: 'Write in with suggestions or problems you have.',
  contactPrompt: 'Email address, if you want to hear back',
  buttonText: 'Send',
  color: DEFAULT_COLOR
});

var css$2 = ".FBWChatForm {\n  display: flex;\n  flex-direction: column;\n\n  font-size: 10pt;\n  line-height: 10pt;\n}\n\n.FBWChatForm-MessageHistoryScrollContainer {\n  flex: 1;\n  overflow: scroll;\n  justify-content: flex-end;\n\n  background: #f9f9f9;\n}\n\n.FBWChatForm-MessageHistory {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  margin-bottom: 20px;\n  min-height: min-content;\n\n  margin: 10px;\n}\n\n\n.FBWChatForm input {\n  padding: 15px;\n  outline: none;\n  border: none;\n}\n";
styleInject(css$2);
var css$3 = ".FBWChatMessage {\n\tposition: relative;\n\tbackground: #2196F3;\n\tborder-radius: .4em;\n\n\talign-self: flex-start;\n\tpadding: 10px;\n\tcolor: white;\n\tmargin: 2px 0px;\n\n\ttext-align: left;\n}\n.FBWChatMessage--right {\n\tbackground: #607d8b;\n\ttext-align: right;\n}\n\n.FBWChatMessage-after {\n\tcontent: '';\n\tposition: absolute;\n\ttop: 50%;\n\twidth: 0;\n\theight: 0;\n\tborder: 0.5em solid transparent;\n\tmargin-top: -0.5em;\n}\n\n.FBWChatMessage--right .FBWChatMessage-after {\n\tright: 0;\n\tborder-left-color: #607d8b;\n\tborder-right: 0;\n\tmargin-right: -0.5em;\n}\n\n.FBWChatMessage--left .FBWChatMessage-after  {\n\tleft: 0;\n\tborder-right-color: #2196F3;\n\tborder-left: 0;\n\tmargin-left: -0.5em;\n}\n";
styleInject(css$3);

function textColorFor(color) {
  return tinycolor(color).isDark() ? 'white' : '#222222';
}

var ChatMessage =
/*#__PURE__*/
function (_Component) {
  _inherits(ChatMessage, _Component);

  function ChatMessage() {
    _classCallCheck(this, ChatMessage);

    return _possibleConstructorReturn(this, _getPrototypeOf(ChatMessage).apply(this, arguments));
  }

  _createClass(ChatMessage, [{
    key: "render",
    value: function render() {
      var side = this.props.side;
      return React.createElement("div", {
        className: classnames({
          "FBWChatMessage": true,
          "FBWChatMessage--left": side === 'left',
          "FBWChatMessage--right": side === 'right'
        }),
        style: {
          background: this.props.color,
          color: textColorFor(this.props.color),
          alignSelf: this.props.side === 'right' ? 'flex-end' : 'flex-start'
        }
      }, this.props.children, React.createElement("span", {
        className: "FBWChatMessage-after",
        style: {
          borderLeftColor: this.props.color,
          borderRightColor: this.props.color
        }
      }));
    }
  }]);

  return ChatMessage;
}(Component);

var ChatFormUI =
/*#__PURE__*/
function (_Component) {
  _inherits(ChatFormUI, _Component);

  function ChatFormUI() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ChatFormUI);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ChatFormUI)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      text: '',
      isSubmitting: false
    });

    _defineProperty(_assertThisInitialized(_this), "setLastMessageRef", function (ref) {
      _this.lastMessageRef = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (event) {
      _this.setState({
        text: event.target.value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyPress",
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(e) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(e.keyCode !== 13)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                if (!_this.props.onMessageSend) {
                  _context.next = 5;
                  break;
                }

                _context.next = 5;
                return _this.props.onMessageSend(_this.state.text);

              case 5:
                _this.setState({
                  text: ''
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    return _this;
  }

  _createClass(ChatFormUI, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.lastMessageRef) {
        this.scrollToLast(false);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(oldProps) {
      if (this.props.messages.length > oldProps.messages.length) {
        this.scrollToLast(true);
      }
    }
  }, {
    key: "scrollToLast",
    value: function scrollToLast(animated) {
      this.lastMessageRef.base.scrollIntoView({
        behavior: animated ? "smooth" : "instant"
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var firstMessagePrompt = this.props.firstMessagePrompt;
      var messages = this.props.messages || [];
      var messagePrompt = !messages.length && firstMessagePrompt ? firstMessagePrompt : "Type your message..";
      return React.createElement("div", {
        className: "FBWChatForm",
        style: this.props.style
      }, React.createElement("div", {
        className: "FBWChatForm-MessageHistoryScrollContainer"
      }, React.createElement("div", {
        className: "FBWChatForm-MessageHistory"
      }, messages.map(function (message, idx) {
        if (idx == messages.length - 1) {
          return _this2.renderMessage(idx, message, {
            ref: _this2.setLastMessageRef
          });
        } else {
          return _this2.renderMessage(idx, message);
        }
      }))), React.createElement("input", {
        className: "FBWChatForm-InputField",
        type: "text",
        placeholder: messagePrompt,
        onKeyPress: this.handleKeyPress,
        onInput: this.handleChange,
        value: this.state.text
      }));
    }
  }, {
    key: "renderMessage",
    value: function renderMessage(key, message, opts) {
      var from = message.from;

      if (!from) {
        return null;
      }

      var messageIsByViewer = from.type == this.props.viewerType && from.id == this.props.viewerId;
      return React.createElement(ChatMessage, _extends({
        key: key,
        side: messageIsByViewer ? 'right' : 'left',
        color: messageIsByViewer ? this.props.viewerColor : this.props.otherColor
      }, opts), message.text);
    }
  }]);

  return ChatFormUI;
}(Component);

_defineProperty(ChatFormUI, "defaultProps", {
  messages: []
});

var ChatForm =
/*#__PURE__*/
function (_Component) {
  _inherits(ChatForm, _Component);

  function ChatForm() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ChatForm);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ChatForm)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleMessageSend",
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(text) {
        var _ref2, chatId;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.chatId) {
                  _context.next = 8;
                  break;
                }

                _context.next = 3;
                return _this.manager.newChat({
                  message: text
                });

              case 3:
                _ref2 = _context.sent;
                chatId = _ref2.id;

                _this.setState({
                  chatId: chatId
                });

                _context.next = 10;
                break;

              case 8:
                _context.next = 10;
                return _this.manager.sendMessage({
                  chatId: _this.chatId,
                  message: text
                });

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    return _this;
  }

  _createClass(ChatForm, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.initializeFromProps({
        chatId: null
      }, {
        chatId: this.props.chatId
      });
    }
  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate(nextProps, nextState) {
      this.initializeFromProps({
        chatId: this.chatId
      }, {
        chatId: nextProps.chatId || nextState.chatId
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unsubscribe();
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe() {
      if (this.subscription) {
        this.subscription.unsubscribe();
      }
    }
  }, {
    key: "initializeFromProps",
    value: function () {
      var _initializeFromProps = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(old, now) {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(old.chatId === now.chatId)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                if (old.chatId) {
                  this.unsubscribe();
                  this.setState({
                    messages: []
                  });
                }

                if (now.chatId) {
                  this.subscription = this.manager.subscribeToMessages(now.chatId).subscribe({
                    next: function next(messages) {
                      _this2.setState({
                        messages: messages
                      });
                    }
                  });
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function initializeFromProps(_x2, _x3) {
        return _initializeFromProps.apply(this, arguments);
      }

      return initializeFromProps;
    }()
  }, {
    key: "render",
    value: function render() {
      return React.createElement(ChatFormUI, {
        style: this.props.style,
        messages: this.state.messages,
        onMessageSend: this.handleMessageSend,
        firstMessagePrompt: this.props.firstMessagePrompt,
        viewerType: "visitor",
        viewerId: this.manager.getVisitorId(),
        viewerColor: this.props.viewerColor,
        otherColor: this.props.otherColor
      });
    }
  }, {
    key: "manager",
    get: function get() {
      return this.props.manager || getDefaultManager();
    }
  }, {
    key: "chatId",
    get: function get() {
      return this.props.chatId || this.state.chatId;
    }
  }]);

  return ChatForm;
}(Component);

_defineProperty(ChatForm, "defaultProps", {
  chatId: ''
});

var css$4 = ".FBWChatList {\n  overflow-y: scroll;\n}\n\n.FBWChatListRow {\n  padding: 20px;\n  border-bottom: 1px solid silver;\n  display: flex;\n  flex-direction: column;\n\n  cursor: pointer;\n  transition: background 300ms ease-in-out;\n}\n\n.FBWChatListRow:hover {\n  background: #FFF3E0;\n}\n\n\n.FBWChatListRow__MetaLine {\n  font-size: small;\n  color: gray;\n}\n\n.FBWChatListRow__Name {\n  float: left;\n}\n\n.FBWChatListRow__Date {\n  float: right;\n}\n\n.FBWChatListRow__LastMessage {\n  font-size: small;\n}\n";
styleInject(css$4);

function getChatterName(chatter) {
  if (chatter.name) {
    return chatter.name;
  }

  if (chatter.type == 'operator') {
    return "Support Team";
  } // Should never happen


  return "Anonymous";
}

var ChatList =
/*#__PURE__*/
function (_Component) {
  _inherits(ChatList, _Component);

  function ChatList() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ChatList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ChatList)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "renderChatRow", function (chat) {
      var _this$props = _this.props,
          viewerId = _this$props.viewerId,
          viewerType = _this$props.viewerType;
      var message = chat.latestMessage;
      var otherChatters = chat.participants.filter(function (p) {
        return p.type !== viewerType && p.id !== viewerId;
      });
      return React.createElement("div", {
        className: "FBWChatListRow",
        onClick: function onClick() {
          return _this.handleChatSelected(chat);
        }
      }, React.createElement("div", {
        className: "FBWChatListRow__MetaLine"
      }, React.createElement("span", {
        className: "FBWChatListRow__Name"
      }, otherChatters.map(function (chatter) {
        return getChatterName(chatter);
      }).join(', ')), React.createElement("span", {
        className: "FBWChatListRow__Date"
      }, distanceInWordsStrict(message.createdAt, new Date()))), React.createElement("div", {
        className: "FBWChatListRow__LastMessage"
      }, message.text));
    });

    _defineProperty(_assertThisInitialized(_this), "handleChatSelected", function (chat) {
      if (_this.props.onSelectChat) {
        _this.props.onSelectChat(chat);
      }
    });

    return _this;
  }

  _createClass(ChatList, [{
    key: "render",
    value: function render() {
      var chats = this.props.chats;
      return React.createElement("div", {
        className: "FBWChatList"
      }, chats.map(this.renderChatRow));
    }
  }]);

  return ChatList;
}(Component);

var css$5 = ".FBWMessenger {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n";
styleInject(css$5);
/**
 * - Element
 * - Component
 * - Text
 * - createElement result
 * - HTML
 * - A promise
 *
 * - A function that returns any of these.
 */

function resolveComponent(something, opts) {
  if (something instanceof HTMLMark) {
    return React.createElement(RenderHTMLString, {
      html: something.text
    });
  } else if (something instanceof Element) {
    return React.createElement(RenderDOMElement, {
      element: something
    });
  } else if (something && something.then) {
    return React.createElement(RenderPromise, {
      promise: something
    });
  } else if (something && something.prototype instanceof Component) {
    return createElement(something, opts);
  } else if (typeof something === 'function') {
    return resolveComponent(something(opts), opts);
  }

  return something;
}
/**
 * This is to mark a string as an HTML-string.
 */


var HTMLMark = function HTMLMark(text) {
  _classCallCheck(this, HTMLMark);

  this.text = text;
};
/**
 * Our UI should be extensible from the outside; the user may not be using
 * React/Preact. If they ever pass a non-http element, we wrap it inside
 * one of these components.
 */


var RenderHTMLString =
/*#__PURE__*/
function (_Component) {
  _inherits(RenderHTMLString, _Component);

  function RenderHTMLString() {
    _classCallCheck(this, RenderHTMLString);

    return _possibleConstructorReturn(this, _getPrototypeOf(RenderHTMLString).apply(this, arguments));
  }

  _createClass(RenderHTMLString, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          html = _this$props.html,
          element = _this$props.element;
      return React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: html
        }
      });
    }
  }]);

  return RenderHTMLString;
}(Component);

var RenderDOMElement =
/*#__PURE__*/
function (_Component2) {
  _inherits(RenderDOMElement, _Component2);

  function RenderDOMElement() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, RenderDOMElement);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(RenderDOMElement)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "root", void 0);

    return _this;
  }

  _createClass(RenderDOMElement, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement("span", {
        ref: function ref(_ref) {
          return _this2.root = _ref;
        }
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.root.appendChild(this.props.element);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.root.removeChild(this.props.element);
    }
  }]);

  return RenderDOMElement;
}(Component);

var RenderPromise =
/*#__PURE__*/
function (_Component3) {
  _inherits(RenderPromise, _Component3);

  function RenderPromise() {
    var _getPrototypeOf3;

    var _this3;

    _classCallCheck(this, RenderPromise);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this3 = _possibleConstructorReturn(this, (_getPrototypeOf3 = _getPrototypeOf(RenderPromise)).call.apply(_getPrototypeOf3, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this3), "state", {
      content: null
    });

    _defineProperty(_assertThisInitialized(_this3), "handleResolved", function (resultValue) {
      _this3.setState({
        content: resolveComponent(resultValue)
      });
    });

    return _this3;
  }

  _createClass(RenderPromise, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.props.promise.then(this.handleResolved);
    }
  }, {
    key: "render",
    value: function render() {
      return this.state.content;
    }
  }]);

  return RenderPromise;
}(Component);
/**
 * This is what we expose through context.
 */


var ProviderInterface =
/*#__PURE__*/
function () {
  function ProviderInterface(pluginHost) {
    _classCallCheck(this, ProviderInterface);

    this._pluginHost = pluginHost;
  }

  _createClass(ProviderInterface, [{
    key: "getComponent",
    value: function getComponent(name, opts, defaultValue) {
      var component = defaultValue;

      if (this.pluginHost) {
        var pluginDefined = this.pluginHost.getComponent(name);

        if (pluginDefined) {
          component = pluginDefined;
        }
      }

      return resolveComponent(component, opts);
    }
  }, {
    key: "pluginHost",
    get: function get() {
      return this._pluginHost || getDefaultPluginHost();
    }
  }]);

  return ProviderInterface;
}();

var NullProviderInterface =
/*#__PURE__*/
function (_ProviderInterface) {
  _inherits(NullProviderInterface, _ProviderInterface);

  function NullProviderInterface() {
    _classCallCheck(this, NullProviderInterface);

    return _possibleConstructorReturn(this, _getPrototypeOf(NullProviderInterface).apply(this, arguments));
  }

  _createClass(NullProviderInterface, [{
    key: "pluginHost",
    get: function get() {
      return null;
    }
  }]);

  return NullProviderInterface;
}(ProviderInterface);

var nullProviderInterface = new NullProviderInterface();

function getDefaultProviderInterface() {
  return nullProviderInterface;
}

var anyPropType = function anyPropType(props, propName, component) {};
/**
 * A react component exposing ProviderInterface via the context.
 */


var Provider =
/*#__PURE__*/
function (_Component) {
  _inherits(Provider, _Component);

  function Provider(props) {
    var _this;

    _classCallCheck(this, Provider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Provider).call(this));
    _this.providerInterface = new ProviderInterface(props.pluginHost);
    return _this;
  }

  _createClass(Provider, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        fbwuiProvider: this.providerInterface
      };
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children[0];
    }
  }]);

  return Provider;
}(Component);

_defineProperty(Provider, "childContextTypes", {
  fbwuiProvider: anyPropType()
});
/**
 * how do we pass down the props for changing for example the bubble colors?
 */


var Messenger =
/*#__PURE__*/
function (_Component) {
  _inherits(Messenger, _Component);

  function Messenger() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Messenger);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Messenger)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      chats: [],
      selectedChatId: null,
      currentView: null
    });

    _defineProperty(_assertThisInitialized(_this), "handleChatSelected", function (chat) {
      _this.setState({
        selectedChatId: chat.id,
        currentView: 'form'
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleBackButtonClicked", function () {
      _this.setState({
        selectedChatId: null,
        currentView: 'list'
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleCloseButtonClicked", function () {
      if (_this.props.onRequestClose) {
        _this.props.onRequestClose();
      }
    });

    return _this;
  }

  _createClass(Messenger, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this2 = this;

      this.subscription = this.manager.subscribeToChats().subscribe({
        next: function next(chats) {
          _this2.setState({
            chats: chats
          });
        }
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unsubscribe();
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe() {
      if (this.subscription) {
        this.subscription.unsubscribe();
      }
    }
  }, {
    key: "renderChatForm",
    value: function renderChatForm(chatId) {
      return React.createElement(ChatForm, {
        chatId: chatId,
        manager: this.props.manager,
        firstMessagePrompt: this.props.initialMessagePrompt,
        style: {
          height: '100%'
        },
        viewerColor: this.props.viewerColor,
        otherColor: this.props.otherColor
      });
    }
  }, {
    key: "renderChatList",
    value: function renderChatList() {
      var chats = this.state.chats || [];
      return React.createElement(ChatList, {
        chats: chats,
        onSelectChat: this.handleChatSelected,
        viewerType: "visitor",
        viewerId: this.manager.getVisitorId()
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          restrictToSingleChat = _this$props.restrictToSingleChat,
          showCloseButton = _this$props.showCloseButton;
      var currentView = this.state.currentView;
      var chats = this.state.chats || [];
      var content;
      var showBackButton;

      if (restrictToSingleChat) {
        var chatId;

        if (chats.length) {
          chatId = chats[0].id;
        }

        content = this.renderChatForm(chatId);
        showBackButton = false;
      } else if (currentView === 'form' && this.state.selectedChatId) {
        content = this.renderChatForm(this.state.selectedChatId);
        showBackButton = true;
      } else if (currentView === 'list') {
        content = this.renderChatList();
        showBackButton = false;
      } else if (chats.length === 0) {
        content = this.renderChatForm(null);
        showBackButton = false;
      } else if (chats.length === 1) {
        content = this.renderChatForm(chats[0].id);
        showBackButton = true;
      } else {
        content = this.renderChatList();
        showBackButton = false;
      }

      var subtitleComponent = this.provider.getComponent('header-subtitle', {
        mode: 'messenger',
        manager: this.props.manager,
        chatId: this.state.selectedChatId
      }, this.props.subtitle);
      return React.createElement("div", {
        className: "FBWMessenger"
      }, React.createElement(Header, {
        color: this.props.color,
        title: this.props.title,
        subtitle: subtitleComponent,
        onBackButtonClick: this.handleBackButtonClicked,
        showBackButton: showBackButton,
        showCloseButton: showCloseButton,
        onCloseButtonClick: this.handleCloseButtonClicked
      }), content);
    }
  }, {
    key: "manager",
    get: function get() {
      return this.props.manager || getDefaultManager();
    }
  }, {
    key: "provider",
    get: function get() {
      return this.context.fbwuiProvider || getDefaultProviderInterface();
    }
  }]);

  return Messenger;
}(Component);

_defineProperty(Messenger, "defaultProps", {
  messages: []
});

_defineProperty(Messenger, "contextTypes", {
  fbwuiProvider: function fbwuiProvider() {}
});

var Widget =
/*#__PURE__*/
function (_Component) {
  _inherits(Widget, _Component);

  function Widget() {
    _classCallCheck(this, Widget);

    return _possibleConstructorReturn(this, _getPrototypeOf(Widget).apply(this, arguments));
  }

  _createClass(Widget, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          mode = _this$props.mode,
          title = _this$props.title,
          color = _this$props.color,
          prompt = _this$props.prompt,
          manager = _this$props.manager,
          restrictToSingleChat = _this$props.restrictToSingleChat,
          showCloseButton = _this$props.showCloseButton,
          onRequestClose = _this$props.onRequestClose,
          style = _this$props.style,
          subtitle = _this$props.subtitle,
          pluginHost = _this$props.pluginHost;
      var sharedProps = {
        color: color,
        manager: manager,
        style: style,
        showCloseButton: showCloseButton,
        onRequestClose: onRequestClose,
        title: title,
        subtitle: subtitle
      };
      var content;

      if (mode === 'contactForm') {
        content = React.createElement(ContactForm, _extends({}, sharedProps, {
          textPrompt: prompt
        }));
      }

      if (mode === 'chat') {
        content = React.createElement(Messenger, _extends({}, sharedProps, {
          initialMessagePrompt: prompt,
          restrictToSingleChat: restrictToSingleChat,
          viewerColor: color,
          otherColor: "#e6e6e6"
        }));
      } // TODO: For getComponent(), instead of using the context, we
      // could possibly also pass a dictionary of components via props.


      return React.createElement(Provider, {
        pluginHost: pluginHost
      }, content);
    }
  }, {
    key: "focus",
    value: function focus() {
      var findFirst = this.base.querySelector('input, textarea');

      if (findFirst) {
        findFirst.focus();
      }
    }
  }]);

  return Widget;
}(Component); //

/**
 * Based on https://github.com/MiguelCastillo/load-js/blob/master/index.js
 *
 * - Added support for a target document, such as an iframe.
 */


var cache = {};

function getHead(targetDocument) {
  return targetDocument.getElementsByTagName("head")[0] || targetDocument.documentElement;
}

function exec(options) {
  if (typeof options === "string") {
    options = {
      url: options
    };
  }

  var targetDocument = options.document || document;
  var cacheId = options.id || options.url;
  var cacheEntry = cache[cacheId];

  if (cacheEntry) {
    console.log("load-js: cache hit", cacheId);
    return cacheEntry;
  } else if (options.allowExternal !== false) {
    var el = getScriptById(options.id, targetDocument) || getScriptByUrl(options.url, targetDocument);

    if (el) {
      var promise = Promise.resolve(el);

      if (cacheId) {
        cache[cacheId] = promise;
      }

      return promise;
    }
  }

  if (!options.url && !options.text) {
    throw new Error("load-js: must provide a url or text to load");
  }

  var pending = (options.url ? loadScript : runScript)(getHead(targetDocument), createScript(options, targetDocument));

  if (cacheId && options.cache !== false) {
    cache[cacheId] = pending;
  }

  return pending;
}

function runScript(head, script) {
  head.appendChild(script);
  return Promise.resolve(script);
}

function loadScript(head, script) {
  return new Promise(function (resolve, reject) {
    // Handle Script loading
    var done = false; // Attach handlers for all browsers.
    //
    // References:
    // http://stackoverflow.com/questions/4845762/onload-handler-for-script-tag-in-internet-explorer
    // http://stevesouders.com/efws/script-onload.php
    // https://www.html5rocks.com/en/tutorials/speed/script-loading/
    //

    script.onload = script.onreadystatechange = function () {
      if (!done && (!script.readyState || script.readyState === "loaded" || script.readyState === "complete")) {
        done = true; // Handle memory leak in IE

        script.onload = script.onreadystatechange = null;
        resolve(script);
      }
    };

    script.onerror = reject;
    head.appendChild(script);
  });
}

function createScript(options, targetDocument) {
  var script = targetDocument.createElement("script");
  script.charset = options.charset || "utf-8";
  script.type = options.type || "text/javascript";
  script.async = !!options.async;
  script.id = options.id || options.url;
  script.loadJS = "watermark";

  if (options.url) {
    script.src = options.url;
  }

  if (options.text) {
    script.text = options.text;
  }

  return script;
}

function getScriptById(id, targetDocument) {
  var script = id && targetDocument.getElementById(id);

  if (script && script.loadJS !== "watermark") {
    console.warn("load-js: duplicate script with id:", id);
    return script;
  }
}

function getScriptByUrl(url, targetDocument) {
  var script = url && targetDocument.querySelector("script[src='" + url + "']");

  if (script && script.loadJS !== "watermark") {
    console.warn("load-js: duplicate script with url:", url);
    return script;
  }
}

function load(items) {
  return items instanceof Array ? Promise.all(items.map(exec)) : exec(items);
}

var API =
/*#__PURE__*/
function () {
  function API(widgetId) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, API);

    this.widgetId = widgetId;
    this.opts = opts;
  }

  _createClass(API, [{
    key: "setVisitorAuth",
    value: function setVisitorAuth(authKey) {
      this.visitorAuthKey = authKey;
    }
  }, {
    key: "_apiRequest",
    value: function () {
      var _apiRequest2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(url, opts) {
        var contentType, response, data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                opts = _objectSpread({}, opts);

                if (opts.data) {
                  opts.body = JSON.stringify(opts.data);
                  delete opts.data;
                  contentType = 'application/json';
                }

                if (!opts.headers) {
                  opts.headers = {};
                }

                if (contentType) {
                  opts.headers['content-Type'] = contentType;
                }

                opts.headers['X-Widget-ID'] = this.widgetId;

                if (this.visitorAuthKey) {
                  opts.headers['authorization'] = "Visitor ".concat(this.visitorAuthKey);
                }

                _context.next = 10;
                return fetch("".concat(this.apiUrl).concat(url), opts);

              case 10:
                response = _context.sent;
                _context.next = 13;
                return response.json();

              case 13:
                data = _context.sent;

                if (!data.error) {
                  _context.next = 16;
                  break;
                }

                throw new Error(data.error);

              case 16:
                return _context.abrupt("return", data);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _apiRequest(_x, _x2) {
        return _apiRequest2.apply(this, arguments);
      }

      return _apiRequest;
    }()
    /**
     * This will create or update the visitor record on the server.
     */

  }, {
    key: "updateVisitor",
    value: function () {
      var _updateVisitor = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(data) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._apiRequest("/visitor", {
                  method: 'POST',
                  data: data
                });

              case 2:
                return _context2.abrupt("return", _context2.sent);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function updateVisitor(_x3) {
        return _updateVisitor.apply(this, arguments);
      }

      return updateVisitor;
    }()
  }, {
    key: "subscribeToMessages",
    value: function () {
      var _subscribeToMessages = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(visitorId, callback) {
        var socket, channelName, channel;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return ensurePusherIsLoaded();

              case 2:
                socket = new window.Pusher('3bf0e1f2f60c1281d8db', {
                  cluster: 'eu',
                  //authEndpoint: 'http://example.com/pusher/auth',
                  encrypted: true
                });
                channelName = "visitor-".concat(visitorId);
                channel = socket.subscribe(channelName);
                channel.bind('message', function (data) {
                  callback(data);
                });
                return _context3.abrupt("return", function () {
                  channel.unsubscribe(channelName);
                });

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function subscribeToMessages(_x4, _x5) {
        return _subscribeToMessages.apply(this, arguments);
      }

      return subscribeToMessages;
    }()
  }, {
    key: "getChats",
    value: function () {
      var _getChats = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(visitorId) {
        var _ref, chats;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this._apiRequest("/visitors/".concat(visitorId, "/chats"), {
                  method: 'GET'
                });

              case 2:
                _ref = _context4.sent;
                chats = _ref.chats;
                return _context4.abrupt("return", chats);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getChats(_x6) {
        return _getChats.apply(this, arguments);
      }

      return getChats;
    }()
  }, {
    key: "getMessages",
    value: function () {
      var _getMessages = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(chatId, count, offset) {
        var _ref2, messages;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this._apiRequest("/chats/".concat(chatId, "/messages"), {
                  method: 'GET'
                });

              case 2:
                _ref2 = _context5.sent;
                messages = _ref2.messages;
                return _context5.abrupt("return", messages);

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getMessages(_x7, _x8, _x9) {
        return _getMessages.apply(this, arguments);
      }

      return getMessages;
    }()
    /**
     * Begins a new conversation. This may be routed to a different
     * agent, and may relate to a different subject. Depending on the
     * use-case, you may limit a user to a single conversation at
     * a time via the UI. A conversation may be  marked as closed by
     * you, by the customer, or by time, indicating that a new thread
     * should be started.
     */

  }, {
    key: "newChat",
    value: function () {
      var _newChat = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(opts) {
        var chat;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this._apiRequest("/chats", {
                  method: 'POST',
                  data: {
                    widget_id: this.widgetId,
                    message: {
                      text: opts.message
                    }
                  }
                });

              case 2:
                chat = _context6.sent;
                return _context6.abrupt("return", chat);

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function newChat(_x10) {
        return _newChat.apply(this, arguments);
      }

      return newChat;
    }()
    /**
     * Add a message to an existing conversation.
     */

  }, {
    key: "sendMessage",
    value: function () {
      var _sendMessage = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7(opts) {
        var message;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this._apiRequest("/messages", {
                  method: 'POST',
                  data: {
                    chat_id: opts.chatId,
                    text: opts.message
                  }
                });

              case 2:
                message = _context7.sent;
                return _context7.abrupt("return", message);

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function sendMessage(_x11) {
        return _sendMessage.apply(this, arguments);
      }

      return sendMessage;
    }()
    /**
     * Send a one-off message. This was designed for a contact-form
     * like mode. Every message sent this way will be in it's own,
     * fresh conversation thread ("chat").
     */

  }, {
    key: "sendMessageOld",
    value: function sendMessageOld(message, contact) {
      return this._apiRequest("/w/".concat(this.widgetId), {
        method: 'POST',
        data: {
          message: message,
          sender: contact
        }
      });
    }
  }, {
    key: "apiUrl",
    get: function get() {
      return this.opts.apiUrl || hasGlobalConfig() && getGlobalConfig().apiUrl || 'https://api.feedbackwidget.io';
    }
  }]);

  return API;
}();
/**
 * To receive messages, we use pusher. We load it's client-side
 * library dynamically, and globally, to remove the size of the
 * bundle.
 */


function ensurePusherIsLoaded() {
  return _ensurePusherIsLoaded.apply(this, arguments);
}

function _ensurePusherIsLoaded() {
  _ensurePusherIsLoaded = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee8() {
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            if (!window.Pusher) {
              _context8.next = 2;
              break;
            }

            return _context8.abrupt("return", Promise.resolve(true));

          case 2:
            return _context8.abrupt("return", load({
              url: 'https://js.pusher.com/4.2/pusher.min.js'
            }));

          case 3:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _ensurePusherIsLoaded.apply(this, arguments);
}

var DefaultState = {
  widget: null,
  chatList: [],
  chatsById: {},
  messageListByChat: {},
  messagesById: {}
};

function reducer(state, action) {
  if (action.type === 'RESET') {
    return DefaultState;
  }

  if (action.type === 'SET_CHATS') {
    var chats = action.chats;
    var chatsById = {};
    chats.forEach(function (c) {
      return chatsById[c.id] = c;
    });
    var chatList = chats.map(function (c) {
      return c.id;
    });
    return {
      chatsById: chatsById,
      chatList: chatList
    };
  }

  if (action.type === 'ADD_MESSAGE') {
    var chatId = action.chatId,
        message = action.message;

    if (state.messagesById[message.id]) {
      var messagesById = _objectSpread({}, state.messagesById, _defineProperty({}, message.id, message));

      return {
        messagesById: messagesById
      };
    } else {
      var existingMessageList = state.messageListByChat[chatId] || [];
      var messageList = [].concat(_toConsumableArray(existingMessageList), [message.id]);

      var _messagesById = _objectSpread({}, state.messagesById, _defineProperty({}, message.id, message));

      var messageListByChat = setMessageListForChat(state, chatId, messageList);
      return {
        messagesById: _messagesById,
        messageListByChat: messageListByChat
      };
    }
  }

  if (action.type === 'SET_MESSAGES') {
    var messages = action.messages,
        _chatId = action.chatId; // Group all messages by id

    var _messagesById2 = _objectSpread({}, state.messagesById);

    messages.forEach(function (m) {
      return _messagesById2[m.id] = m;
    }); // Fetch all the ids

    var newMessageList = messages.map(function (m) {
      return m.id;
    });

    var _messageListByChat = setMessageListForChat(state, _chatId, newMessageList);

    return {
      messagesById: _messagesById2,
      messageListByChat: _messageListByChat
    };
  }

  return state;
}

function setMessageListForChat(state, chatId, messageList) {
  var messageListByChat = _objectSpread({}, state.messageListByChat);

  messageListByChat[chatId] = messageList;
  return messageListByChat;
}

function makePartialStateReducer(reducer) {
  return function (state, action) {
    var partialState = reducer(state, action);

    var mergedState = _objectSpread({}, state, partialState);

    return mergedState;
  };
}

var makeStore = function makeStore() {
  return new createStore(makePartialStateReducer(reducer), DefaultState);
};

function getChats(state) {
  return state.chatList.map(function (id) {
    return state.chatsById[id];
  });
}

function getMessagesFromChat(state, chatId) {
  var messageList = state.messageListByChat[chatId];

  if (!messageList) {
    return [];
  }

  return messageList.map(function (id) {
    return state.messagesById[id];
  });
}

function subscribeToSelector(store, selectorFunc) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var observable = new Observable(function (observer) {
    observer.next(selectorFunc(store.getState()));
    var lastValue;
    return store.subscribe(function () {
      var newValue = selectorFunc.apply(void 0, [store.getState()].concat(args));

      if (newValue !== lastValue) {
        observer.next(newValue);
        lastValue = newValue;
      }
    });
  });
  return observable;
}

var Manager =
/*#__PURE__*/
function () {
  // TODO: If the widget id changes for a domain, we should expire all
  // the existing visitor auth keys.
  function Manager(widgetId) {
    var _this = this;

    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Manager);

    _defineProperty(this, "_handleServerMessage", function (msg) {
      console.log('message received from server', msg);

      _this.reduxStore.dispatch({
        type: 'ADD_MESSAGE',
        message: msg,
        chatId: msg.chatId
      });
    });

    this.api = new API(widgetId, opts);

    this._setVisitor(JSON.parse(window.localStorage.getItem('io.feedbackwidget.visitor')));

    this.reduxStore = makeStore();
  }

  _createClass(Manager, [{
    key: "getVisitorId",
    value: function getVisitorId() {
      return this.visitor ? this.visitor.id : null;
    }
  }, {
    key: "ensureIdentified",
    value: function () {
      var _ensureIdentified = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.hasVisitor) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return this.identify({});

              case 3:
                return _context.abrupt("return", this.visitor);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function ensureIdentified() {
        return _ensureIdentified.apply(this, arguments);
      }

      return ensureIdentified;
    }()
  }, {
    key: "identify",
    value: function () {
      var _identify = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(data) {
        var visitor;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.api.updateVisitor(data || {});

              case 2:
                visitor = _context2.sent; // Did the visitor id change? Reload all the data, then...

                if (this.visitor && (!visitor || visitor.id && this.visitor.id !== visitor.id)) {
                  this.logout();
                }

                this._setVisitor(visitor);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function identify(_x) {
        return _identify.apply(this, arguments);
      }

      return identify;
    }()
  }, {
    key: "logout",
    value: function logout() {
      this._unsubscribeAll();

      this.reduxStore.dispatch({
        type: 'RESET'
      });

      this._setVisitor(null);
    }
  }, {
    key: "_unsubscribeAll",
    value: function _unsubscribeAll() {
      this._unsubscribeFromServer();

      this._unsubscribeFromServer = null;
    }
  }, {
    key: "_setVisitor",
    value: function _setVisitor(visitor) {
      this.visitor = visitor;

      if (visitor) {
        this.api.setVisitorAuth(visitor.auth_key);
      } else {
        this.api.setVisitorAuth("");
      }

      window.localStorage.setItem('io.feedbackwidget.visitor', JSON.stringify(visitor)); // We did not yet subscribe to the messages for this visitor

      var visitorId = this.getVisitorId();

      if (!this._unsubscribeFromServer && visitorId) {
        this.api.subscribeToMessages(visitorId, this._handleServerMessage);
      }
    }
  }, {
    key: "newChat",
    value: function () {
      var _newChat = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var _this$api;

        var chat,
            _args3 = arguments;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.ensureIdentified();

              case 2:
                _context3.next = 4;
                return (_this$api = this.api).newChat.apply(_this$api, _args3);

              case 4:
                chat = _context3.sent;
                this.reduxStore.dispatch({
                  type: 'ADD_CHAT',
                  chat: chat
                });
                return _context3.abrupt("return", chat);

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function newChat() {
        return _newChat.apply(this, arguments);
      }

      return newChat;
    }()
  }, {
    key: "sendMessage",
    value: function () {
      var _sendMessage = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(message) {
        var messageObj;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.ensureIdentified();

              case 2:
                _context4.next = 4;
                return this.api.sendMessage(message);

              case 4:
                messageObj = _context4.sent;
                this.reduxStore.dispatch({
                  type: 'ADD_MESSAGE',
                  message: messageObj,
                  chatId: message.chatId
                });

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function sendMessage(_x2) {
        return _sendMessage.apply(this, arguments);
      }

      return sendMessage;
    }() // Get updates on open chats.

  }, {
    key: "subscribeToChats",
    value: function subscribeToChats(handlers) {
      var _this2 = this;

      var observable = subscribeToSelector(this.reduxStore, getChats); // Query the initial set of chats.
      // NB: If there is no visitor yet, there will be no chats.
      // Delay the query.

      if (this.visitor) {
        this.api.getChats(this.visitor.id).then(function (chats) {
          _this2.reduxStore.dispatch({
            type: 'SET_CHATS',
            chats: chats
          });
        });
      }

      return maybeSubscribe(observable);
    } // Get updates on messages in a chat.

  }, {
    key: "subscribeToMessages",
    value: function subscribeToMessages(chatId) {
      var _this3 = this;

      var observable = subscribeToSelector(this.reduxStore, getMessagesFromChat, chatId);
      this.api.getMessages(chatId).then(function (messages) {
        _this3.reduxStore.dispatch({
          type: 'SET_MESSAGES',
          chatId: chatId,
          messages: messages
        });
      });
      return maybeSubscribe(observable);
    }
  }, {
    key: "hasVisitor",
    get: function get() {
      return !!this.visitor;
    }
  }]);

  return Manager;
}();

function maybeSubscribe(observable, handlers) {
  if (handlers) {
    return observable.subscribe(handlers);
  }

  return observable;
}

var manager;

function getDefaultManager$1() {
  if (!manager) {
    var config = getGlobalConfig();

    if (!config.widgetId) {
      throw Error("You have not initialized Feedbackwidget with a widget id. Call FeedbackWidget.set({widgetId: '...'})");
    }

    manager = new Manager(config.widgetId, {
      apiUrl: config.apiUrl
    });
  }

  return manager;
}

function identify(data) {
  getDefaultManager$1().identify(data);
} //


export { API, ChatForm, ChatFormUI, ContactForm, Header, Manager, Messenger, Widget, getDefaultManager$1 as getDefaultManager, identify };